import React, { SVGAttributes } from 'react'

function SummaryIconFirst(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#FEEBCB"
      />
      <path
        d="M30.5855 21.1548C30.546 21.0644 30.4907 20.9817 30.4222 20.9107L25.4222 15.9107C25.3511 15.8422 25.2685 15.7868 25.178 15.7473C25.153 15.7357 25.1263 15.729 25.0997 15.7198C25.0299 15.6961 24.9574 15.6818 24.8838 15.6773C24.8663 15.6757 24.8505 15.6665 24.833 15.6665H18.9997C18.0805 15.6665 17.333 16.414 17.333 17.3332V30.6665C17.333 31.5857 18.0805 32.3332 18.9997 32.3332H28.9997C29.9188 32.3332 30.6663 31.5857 30.6663 30.6665V21.4998C30.6663 21.4823 30.6572 21.4665 30.6555 21.4482C30.6514 21.3746 30.6371 21.302 30.613 21.2323C30.6047 21.2057 30.5972 21.1798 30.5855 21.1548ZM27.8213 20.6665H25.6663V18.5115L27.8213 20.6665ZM18.9997 30.6665V17.3332H23.9997V21.4998C23.9997 21.7209 24.0875 21.9328 24.2438 22.0891C24.4 22.2454 24.612 22.3332 24.833 22.3332H28.9997L29.0013 30.6665H18.9997Z"
        fill="#4A5568"
      />
      <path
        d="M20.667 23.9998H27.3337V25.6665H20.667V23.9998ZM20.667 27.3332H27.3337V28.9998H20.667V27.3332ZM20.667 20.6665H22.3337V22.3332H20.667V20.6665Z"
        fill="#4A5568"
      />
    </svg>
  )
}

function SummaryIconSecond(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#EBF8FF"
      />
      <path
        d="M30.6138 21.2332C30.6047 21.2065 30.5972 21.1807 30.5863 21.1548C30.5468 21.0644 30.4915 20.9817 30.423 20.9107L25.423 15.9107C25.352 15.8422 25.2693 15.7868 25.1788 15.7473C25.1538 15.7357 25.1272 15.729 25.1005 15.7198C25.0308 15.6961 24.9582 15.6818 24.8847 15.6773C24.8663 15.6757 24.8505 15.6665 24.833 15.6665H18.9997C18.0805 15.6665 17.333 16.414 17.333 17.3332V30.6665C17.333 31.5857 18.0805 32.3332 18.9997 32.3332H28.9997C29.9188 32.3332 30.6663 31.5857 30.6663 30.6665V21.4998C30.6663 21.4823 30.6572 21.4665 30.6555 21.4482C30.6512 21.375 30.6372 21.3027 30.6138 21.2332V21.2332ZM27.8213 20.6665H25.6663V18.5115L27.8213 20.6665ZM18.9997 30.6665V17.3332H23.9997V21.4998C23.9997 21.7209 24.0875 21.9328 24.2438 22.0891C24.4 22.2454 24.612 22.3332 24.833 22.3332H28.9997L29.0013 30.6665H18.9997Z"
        fill="#4A5568"
      />
    </svg>
  )
}

function SummaryIconThird(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#FAE6E5"
      />
      <path
        d="M30.6667 16.5H17.3333C17.1123 16.5 16.9004 16.5878 16.7441 16.7441C16.5878 16.9004 16.5 17.1123 16.5 17.3333V30.6667C16.5 30.8877 16.5878 31.0996 16.7441 31.2559C16.9004 31.4122 17.1123 31.5 17.3333 31.5H30.6667C30.8877 31.5 31.0996 31.4122 31.2559 31.2559C31.4122 31.0996 31.5 30.8877 31.5 30.6667V17.3333C31.5 17.1123 31.4122 16.9004 31.2559 16.7441C31.0996 16.5878 30.8877 16.5 30.6667 16.5V16.5ZM29.8333 29.8333H18.1667V18.1667H29.8333V29.8333Z"
        fill="#4A5568"
      />
      <path
        d="M23.167 19.8335H24.8337V21.5002H23.167V19.8335ZM23.167 23.1668H24.8337V28.1668H23.167V23.1668Z"
        fill="#4A5568"
      />
    </svg>
  )
}

function SummaryIconForth(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#E5ECF9"
      />
      <path
        d="M18.1667 32.3332H29.8333C30.7525 32.3332 31.5 31.5857 31.5 30.6665V18.1665C31.5 17.2473 30.7525 16.4998 29.8333 16.4998H28.1667C28.1667 16.2788 28.0789 16.0669 27.9226 15.9106C27.7663 15.7543 27.5543 15.6665 27.3333 15.6665H20.6667C20.4457 15.6665 20.2337 15.7543 20.0774 15.9106C19.9211 16.0669 19.8333 16.2788 19.8333 16.4998H18.1667C17.2475 16.4998 16.5 17.2473 16.5 18.1665V30.6665C16.5 31.5857 17.2475 32.3332 18.1667 32.3332ZM18.1667 18.1665H19.8333V19.8332H28.1667V18.1665H29.8333V30.6665H18.1667V18.1665Z"
        fill="#4A5568"
      />
      <path
        d="M23.1666 25.3215L21.6725 23.8273L20.4941 25.0056L23.1666 27.6781L27.5058 23.339L26.3275 22.1606L23.1666 25.3215Z"
        fill="#4A5568"
      />
    </svg>
  )
}

function SummaryIconFifth(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#FCE8D8"
      />
      <path
        d="M29.8333 17.3332H28.1667V15.6665H26.5V17.3332H21.5V15.6665H19.8333V17.3332H18.1667C17.2475 17.3332 16.5 18.0807 16.5 18.9998V30.6665C16.5 31.5857 17.2475 32.3332 18.1667 32.3332H29.8333C30.7525 32.3332 31.5 31.5857 31.5 30.6665V18.9998C31.5 18.0807 30.7525 17.3332 29.8333 17.3332ZM29.835 30.6665H18.1667V20.6665H29.8333L29.835 30.6665Z"
        fill="#4A5568"
      />
      <path
        d="M23.167 22.3335H24.8337V26.5002H23.167V22.3335ZM23.167 27.3335H24.8337V29.0002H23.167V27.3335Z"
        fill="#4A5568"
      />
    </svg>
  )
}

function SummaryIconSixth(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#E7F8EC"
      />
      <path
        d="M30.667 17.3335H17.3337C16.4145 17.3335 15.667 18.081 15.667 19.0002V29.0002C15.667 29.9193 16.4145 30.6668 17.3337 30.6668H30.667C31.5862 30.6668 32.3337 29.9193 32.3337 29.0002V19.0002C32.3337 18.081 31.5862 17.3335 30.667 17.3335ZM17.3337 19.0002H30.667V20.6668H17.3337V19.0002ZM17.3337 29.0002V24.0002H30.6678L30.6687 29.0002H17.3337Z"
        fill="#4A5568"
      />
      <path d="M19 25.6665H24V27.3332H19V25.6665Z" fill="#4A5568" />
    </svg>
  )
}

function SummaryIconSeventh(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#EDFDFD"
      />
      <path
        d="M24.0003 15.6665C22.3522 15.6665 20.741 16.1552 19.3706 17.0709C18.0002 17.9866 16.9321 19.2881 16.3013 20.8108C15.6706 22.3335 15.5056 24.0091 15.8271 25.6256C16.1487 27.2421 16.9423 28.727 18.1078 29.8924C19.2732 31.0578 20.7581 31.8515 22.3746 32.173C23.9911 32.4946 25.6666 32.3296 27.1894 31.6988C28.7121 31.0681 30.0136 30 30.9292 28.6296C31.8449 27.2592 32.3337 25.648 32.3337 23.9998C32.3337 22.9055 32.1181 21.8219 31.6993 20.8108C31.2805 19.7998 30.6667 18.8811 29.8929 18.1073C29.1191 17.3335 28.2004 16.7196 27.1894 16.3008C26.1783 15.8821 25.0947 15.6665 24.0003 15.6665V15.6665ZM24.0003 30.6665C22.6818 30.6665 21.3929 30.2755 20.2965 29.543C19.2002 28.8104 18.3457 27.7692 17.8411 26.5511C17.3365 25.3329 17.2045 23.9924 17.4618 22.6992C17.719 21.406 18.3539 20.2181 19.2863 19.2858C20.2186 18.3534 21.4065 17.7185 22.6997 17.4613C23.9929 17.204 25.3334 17.3361 26.5516 17.8406C27.7697 18.3452 28.8109 19.1997 29.5435 20.296C30.276 21.3924 30.667 22.6813 30.667 23.9998C30.667 25.7679 29.9646 27.4636 28.7144 28.7139C27.4641 29.9641 25.7684 30.6665 24.0003 30.6665V30.6665Z"
        fill="#4A5568"
      />
      <path
        d="M24.0003 23.1667C22.3337 23.1667 22.3337 22.6417 22.3337 22.3333C22.3337 22.025 22.917 21.5 24.0003 21.5C25.0837 21.5 25.1587 22.0333 25.167 22.3333H26.8337C26.8224 21.7656 26.6182 21.2187 26.2547 20.7825C25.8912 20.3463 25.39 20.0468 24.8337 19.9333V19H23.167V19.9083C21.5003 20.1833 20.667 21.2583 20.667 22.3333C20.667 23.2667 21.1003 24.8333 24.0003 24.8333C25.667 24.8333 25.667 25.4 25.667 25.6667C25.667 25.9333 25.1503 26.5 24.0003 26.5C22.467 26.5 22.3337 25.7833 22.3337 25.6667H20.667C20.667 26.4333 21.217 27.7917 23.167 28.1V29H24.8337V28.1C26.5003 27.8167 27.3337 26.7417 27.3337 25.6667C27.3337 24.7333 26.9003 23.1667 24.0003 23.1667V23.1667Z"
        fill="#4A5568"
      />
    </svg>
  )
}

function SummaryIconEight(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#E2EFDF"
      />
      <path
        d="M30.667 16.5H17.3337C16.4145 16.5 15.667 17.2475 15.667 18.1667V29.8333C15.667 30.7525 16.4145 31.5 17.3337 31.5H30.667C31.5862 31.5 32.3337 30.7525 32.3337 29.8333V18.1667C32.3337 17.2475 31.5862 16.5 30.667 16.5ZM17.3337 29.8333V18.1667H30.667L30.6687 29.8333H17.3337Z"
        fill="#4A5568"
      />
      <path
        d="M19 19.8335H29V21.5002H19V19.8335ZM19 23.1668H29V24.8335H19V23.1668ZM19 26.5002H24V28.1668H19V26.5002Z"
        fill="#4A5568"
      />
    </svg>
  )
}

function SummaryIconNinth(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#FFF5F7"
      />
      <path
        d="M27.3337 15.6665H20.667C17.9095 15.6665 15.667 17.909 15.667 20.6665V31.4998C15.667 31.7209 15.7548 31.9328 15.9111 32.0891C16.0674 32.2454 16.2793 32.3332 16.5003 32.3332H27.3337C30.0912 32.3332 32.3337 30.0907 32.3337 27.3332V20.6665C32.3337 17.909 30.0912 15.6665 27.3337 15.6665ZM30.667 27.3332C30.667 29.1715 29.172 30.6665 27.3337 30.6665H17.3337V20.6665C17.3337 18.8282 18.8287 17.3332 20.667 17.3332H27.3337C29.172 17.3332 30.667 18.8282 30.667 20.6665V27.3332Z"
        fill="#4A5568"
      />
      <path
        d="M26.7431 20.0791L23.9998 22.8224L21.2565 20.0791L20.0781 21.2574L22.8215 24.0008L20.0781 26.7441L21.2565 27.9224L23.9998 25.1791L26.7431 27.9224L27.9215 26.7441L25.1781 24.0008L27.9215 21.2574L26.7431 20.0791Z"
        fill="#4A5568"
      />
    </svg>
  )
}

function SummaryIconTenth(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="#FAF5FF"
      />
      <path
        d="M20.9111 27.5776L22.0895 28.756L24.0003 26.8451L25.9111 28.756L27.0895 27.5776L25.1786 25.6668L27.0895 23.756L25.9111 22.5776L24.0003 24.4885L22.0895 22.5776L20.9111 23.756L22.822 25.6668L20.9111 27.5776Z"
        fill="#4A5568"
      />
      <path
        d="M29.8333 17.3332H28.1667V15.6665H26.5V17.3332H21.5V15.6665H19.8333V17.3332H18.1667C17.2475 17.3332 16.5 18.0807 16.5 18.9998V30.6665C16.5 31.5857 17.2475 32.3332 18.1667 32.3332H29.8333C30.7525 32.3332 31.5 31.5857 31.5 30.6665V18.9998C31.5 18.0807 30.7525 17.3332 29.8333 17.3332ZM29.835 30.6665H18.1667V20.6665H29.8333L29.835 30.6665Z"
        fill="#4A5568"
      />
    </svg>
  )
}
function SummaryIconRevison(props: SVGAttributes<SVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
    <rect width="44.293" height="44.293" rx="22.1465" fill="#FAFFBF"/>
    <path d="M19.2493 20.1666H24.7493C26.2655 20.1666 27.4993 21.4005 27.4993 22.9166C27.4993 24.4328 26.2655 25.6666 24.7493 25.6666H21.9993V27.5H24.7493C27.2766 27.5 29.3327 25.4439 29.3327 22.9166C29.3327 20.3894 27.2766 18.3333 24.7493 18.3333H19.2493V15.5833L14.666 19.25L19.2493 22.9166V20.1666Z" fill="#4A5568"/>
    </svg>
  )
}
function SummaryIconSubmitted(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V24C48 37.2548 37.2548 48 24 48V48C10.7452 48 0 37.2548 0 24V24Z"
        fill="
        #F8FFEC"
      />
      <path
        d="M18.1667 32.3332H29.8333C30.7525 32.3332 31.5 31.5857 31.5 30.6665V18.1665C31.5 17.2473 30.7525 16.4998 29.8333 16.4998H28.1667C28.1667 16.2788 28.0789 16.0669 27.9226 15.9106C27.7663 15.7543 27.5543 15.6665 27.3333 15.6665H20.6667C20.4457 15.6665 20.2337 15.7543 20.0774 15.9106C19.9211 16.0669 19.8333 16.2788 19.8333 16.4998H18.1667C17.2475 16.4998 16.5 17.2473 16.5 18.1665V30.6665C16.5 31.5857 17.2475 32.3332 18.1667 32.3332ZM18.1667 18.1665H19.8333V19.8332H28.1667V18.1665H29.8333V30.6665H18.1667V18.1665Z"
        fill="#4A5568"
      />
      <path
        d="M23.1666 25.3215L21.6725 23.8273L20.4941 25.0056L23.1666 27.6781L27.5058 23.339L26.3275 22.1606L23.1666 25.3215Z"
        fill="#4A5568"
      />
    </svg>
  )
}

function PaidIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M16.1736 3.09998H4.63896C3.36707 3.09998 2.33203 4.13502 2.33203 5.4069V14.6346C2.33203 15.9065 3.36707 16.9415 4.63896 16.9415H16.1736C17.0218 16.9415 17.7115 16.2518 17.7115 15.4036V4.63793C17.7115 3.78975 17.0218 3.09998 16.1736 3.09998ZM4.63896 15.4036C4.21448 15.4036 3.86998 15.0583 3.86998 14.6346V5.4069C3.86998 4.9832 4.21448 4.63793 4.63896 4.63793H16.1736V6.94485H11.5597C10.7116 6.94485 10.0218 7.63463 10.0218 8.48281V11.5587C10.0218 12.4069 10.7116 13.0967 11.5597 13.0967H16.1744V15.4036H4.63896ZM16.1736 8.48281V11.5587H11.5597V8.48281H16.1736Z" fill="#4A5568"/>
    </svg>
  )
}

export default SummaryIconFirst
export {
  SummaryIconSecond,
  SummaryIconThird,
  SummaryIconForth,
  SummaryIconFifth,
  SummaryIconSixth,
  SummaryIconSeventh,
  SummaryIconEight,
  SummaryIconNinth,
  SummaryIconTenth,
  SummaryIconRevison,
  SummaryIconSubmitted,
  PaidIcon
}
